/*
 * Copyright (c) 2018 - Indigen Solutions
 * Authors:
 *   - Bichoy Messiha <bm@indigen.com>
 * NOTICE: All information contained here in is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Indigen Solutions.
 */
import { Paper, Typography, WithStyles, withStyles } from "@material-ui/core";
import * as React from "react";
import { connect } from "react-redux";

import Background from "../../components/Background/Background";
import FormProfil from "../../components/FormProfil/FormProfil";
import { Logo } from "../../components/Logo/Logo";
import { User } from "../../models/User.model";
import { RootState } from "../../types/RootState";
import { styles } from "./PageValidateProfile.style";
import { compose } from "recompose";
import { updateUserAndGoHome } from "../../store/actions";
import { push } from "connected-react-router";

interface PageValidateProfileProps extends WithStyles<typeof styles> {
    user: User;
    updateUserAndGoHome?: typeof updateUserAndGoHome;
    push?: typeof push;
}

class PageValidateProfile extends React.Component<PageValidateProfileProps> {
    onSubmit(user: User) {
        this.props.updateUserAndGoHome(user);
    }

    public render() {
        const { classes, user } = this.props;

        return (
            <Background>
                <Paper className={classes.paper} elevation={4}>
                    <div className={classes.top}>
                        <Typography variant="display1">Valider votre profil</Typography>
                        <Logo color={true} size="small" company={user.company} />
                    </div>
                    <Typography className={classes.intro}>
                        Merci de compléter les informations ci-dessous, afin de créer votre profil. Il sera possible de
                        mettre à jour vos informations en cliquant sur «modifier mon profil».
                    </Typography>
                    <Typography variant="title" className={classes.intro}>
                        Vos informations
                    </Typography>
                    <FormProfil defaultUser={user} onSubmit={this.onSubmit.bind(this)} />
                </Paper>
            </Background>
        );
    }
}

export const PageValidateProfileConnected = compose(
    withStyles(styles),
    connect(
        (state: RootState) => ({
            user: state.me.user,
        }),
        {
            updateUserAndGoHome,
            push,
        }
    )
)(PageValidateProfile);

// For stories
export const PageValidateProfileStyled = withStyles(styles)(PageValidateProfile);



// WEBPACK FOOTER //
// ./src/pages/PageValidateProfile/PageValidateProfile.tsx